
// Flex
export const FLEX_CONTAINER = "flex-container";
export const FLEX_CONTAINER_ROW = "flex-container-row";
export const FLEX_CONTAINER_COLUMN = "flex-container-column";
export const FLEX_CONTAINER_WRAP = "flex-container-wrap";

export const FLEX_CONTAINER_CENTERED = "flex-container-centered";
export const FLEX_CONTAINER_ROW_CENTERED = "flex-container-row-centered";
export const FLEX_CONTAINER_COLUMN_CENTERED = "flex-container-column-centered";

export const FLEX_ITEM = "flex-item";
export const FLEX_ITEM_AUTO = "flex-item-auto";
export const FLEX_ITEM_NONE = "flex-item-none";

// WIDTH
export const W_25 = "w-25";
export const W_50 = "w-50";
export const W_75 = "w-75";
export const W_100 = "w-100";
export const W_AUTO = "w-auto";
export const MIN_WIDTH_100 = "min-w-100";

// HEIGHT
export const H_25 = "h-25";
export const H_50 = "h-50";
export const H_75 = "h-75";
export const H_100 = "h-100";
export const H_AUTO = "h-auto";

// TEXT-TRUNCATE
/**
 * Add text ellipsis class on element
 * @see https://getbootstrap.com/docs/5.0/helpers/text-truncation
 */
export const TEXT_TRUNCATE = "text-truncate";

/**
 * Text transform classes
 * @see https://getbootstrap.com/docs/5.0/utilities/text/
 */
export enum TEXT_TRANSFORM {
    LOWERCASE = "text-lowercase",
    UPPERCASE = "text-uppercase",
    CAPITALIZE = "text-capitalize"
}

/**
 * Text alignment classes
 * @see https://getbootstrap.com/docs/5.3/utilities/text/#text-alignment
 */
export enum TEXT_ALIGN {
    // START
    START = "text-start",
    /** Start aligned text on viewports sized SM (small) or wider. */
    SM_START = "text-sm-start",
    /** Start aligned text on viewports sized MD (medium) or wider. */
    MD_START = "text-md-start",
    /** Start aligned text on viewports sized LG (large) or wider. */
    LG_START = "text-lg-start",
    /** Start aligned text on viewports sized XL (extra-large) or wider. */
    XL_START = "text-xl-start",

    // CENTER
    CENTER = "text-center",
    /** Center aligned text on viewports sized SM (small) or wider. */
    SM_CENTER = "text-sm-center",
    /** Center aligned text on viewports sized MD (medium) or wider. */
    MD_CENTER = "text-md-center",
    /** Center aligned text on viewports sized LG (large) or wider. */
    LG_CENTER = "text-lg-center",
    /** Center aligned text on viewports sized XL (extra-large) or wider. */
    XL_CENTER = "text-xl-center",

    // END
    END = "text-end",
    /** End aligned text on viewports sized SM (small) or wider. */
    SM_END = "text-sm-end",
    /** End aligned text on viewports sized MD (medium) or wider. */
    MD_END = "text-md-end",
    /** End aligned text on viewports sized LG (large) or wider. */
    LG_END = "text-lg-end",
    /** End aligned text on viewports sized XL (extra-large) or wider. */
    XL_END = "text-xl-end",
}


/**
 * Text vertical alignment classes
 * @see https://getbootstrap.com/docs/5.3/utilities/vertical-align/
 */
export enum TEXT_VERTICAL_ALIGN {
    BASELINE = "align-baseline",
    TOP = "align-top",
    MIDDLE = "align-middle",
    BOTTOM = "align-bottom",
    TEXT_TOP = "align-text-top",
    TEXT_BOTTOM = "align-text-bottom",
}

/**
 * Text wrapping classes
 * @see https://getbootstrap.com/docs/5.3/utilities/text/#text-wrapping-and-overflow
 */
export enum TEXT_WRAPPING {
    WRAP = "text-wrap",
    NO_WRAP = "text-nowrap"
}

/**
 * Justify-content classes
 */
export enum JUSTIFY_CONTENT {
    START = "justify-content-start",
    END = "justify-content-end",
    CENTER = "justify-content-center",
    BETWEEN = "justify-content-between",
    AROUND = "justify-content-around",
    EVENLY = "justify-content-evenly"
}

/**
 * Align-items classes
 */
export enum ALIGN_ITEMS {
    START = "align-items-start",
    END = "align-items-end",
    CENTER = "align-items-center",
    BASELINE = "align-items-baseline",
    STRETCH = "align-items-stretch"
}

/**
 * Align-self classes
 */
export enum ALIGN_SELF {
    START = "align-self-start",
    END = "align-self-end",
    CENTER = "align-self-center",
    BASELINE = "align-self-baseline",
    STRETCH = "align-self-stretch"
}

/**
 * Align-content classes
 */
export enum ALIGN_CONTENT {
    START = "align-content-start",
    END = "align-content-end",
    CENTER = "align-content-center",
    AROUND = "align-content-around",
    STRETCH = "align-content-stretch"
}

/**
 * Flex wrap classes
 */
export enum FLEX_WRAP {
    WRAP = "flex-wrap",
    NO_WRAP = "flex-nowrap",
    WRAP_REVERSE = "flex-wrap-reverse"
}

/** 
 * Margin bootstrap classes
 * @see https://getbootstrap.com/docs/5.0/utilities/spacing/
 */
export enum MARGIN {

    // ALL DIRECTIONS
    M_0 = "m-0",
    M_1 = "m-1",
    M_2 = "m-2",
    M_3 = "m-3",
    M_4 = "m-4",
    M_5 = "m-5",
    M_AUTO = "m-auto",

    // TOP
    MT_0 = "mt-0",
    MT_1 = "mt-1",
    MT_2 = "mt-2",
    MT_3 = "mt-3",
    MT_4 = "mt-4",
    MT_5 = "mt-5",
    MT_AUTO = "mt-auto",

    // BOTTOM
    MB_0 = "mb-0",
    MB_1 = "mb-1",
    MB_2 = "mb-2",
    MB_3 = "mb-3",
    MB_4 = "mb-4",
    MB_5 = "mb-5",
    MB_AUTO = "mb-auto",

    // LEFT (start)
    MS_0 = "ms-0",
    MS_1 = "ms-1",
    MS_2 = "ms-2",
    MS_3 = "ms-3",
    MS_4 = "ms-4",
    MS_5 = "ms-5",
    MS_AUTO = "ms-auto",

    // RIGHT (end)
    ME_0 = "me-0",
    ME_1 = "me-1",
    ME_2 = "me-2",
    ME_3 = "me-3",
    ME_4 = "me-4",
    ME_5 = "me-5",
    ME_AUTO = "me-auto",

    // X - both Left and Right
    MX_0 = "mx-0",
    MX_1 = "mx-1",
    MX_2 = "mx-2",
    MX_3 = "mx-3",
    MX_4 = "mx-4",
    MX_5 = "mx-5",
    MX_AUTO = "mx-auto",

    // Y - both Top and Bottom
    MY_0 = "my-0",
    MY_1 = "my-1",
    MY_2 = "my-2",
    MY_3 = "my-3",
    MY_4 = "my-4",
    MY_5 = "my-5",
    MY_AUTO = "my-auto",
}

/** 
 * Padding bootstrap classes
 * @see https://getbootstrap.com/docs/5.0/utilities/spacing/
 */
export enum PADDING {

    // ALL DIRECTIONS
    P_0 = "p-0",
    P_1 = "p-1",
    P_2 = "p-2",
    P_3 = "p-3",
    P_4 = "p-4",
    P_5 = "p-5",
    P_AUTO = "p-auto",

    // TOP
    PT_0 = "pt-0",
    PT_1 = "pt-1",
    PT_2 = "pt-2",
    PT_3 = "pt-3",
    PT_4 = "pt-4",
    PT_5 = "pt-5",
    PT_AUTO = "pt-auto",

    // BOTTOM
    PB_0 = "pb-0",
    PB_1 = "pb-1",
    PB_2 = "pb-2",
    PB_3 = "pb-3",
    PB_4 = "pb-4",
    PB_5 = "pb-5",
    PB_AUTO = "pb-auto",

    // LEFT (start)
    PS_0 = "ps-0",
    PS_1 = "ps-1",
    PS_2 = "ps-2",
    PS_3 = "ps-3",
    PS_4 = "ps-4",
    PS_5 = "ps-5",
    PS_AUTO = "ps-auto",

    // RIGHT (end)
    PE_0 = "pe-0",
    PE_1 = "pe-1",
    PE_2 = "pe-2",
    PE_3 = "pe-3",
    PE_4 = "pe-4",
    PE_5 = "pe-5",
    PE_AUTO = "pe-auto",

    // X - both Left and Right
    PX_0 = "px-0",
    PX_1 = "px-1",
    PX_2 = "px-2",
    PX_3 = "px-3",
    PX_4 = "px-4",
    PX_5 = "px-5",
    PX_AUTO = "px-auto",

    // Y - both Top and Bottom
    PY_0 = "py-0",
    PY_1 = "py-1",
    PY_2 = "py-2",
    PY_3 = "py-3",
    PY_4 = "py-4",
    PY_5 = "py-5",
    PY_AUTO = "py-auto",
}

/**
 * Overflow classes
 */
export enum OVERFLOW {
    AUTO = "overflow-auto",
    HIDDEN = "overflow-hidden",
    VISIBLE = "overflow-visible",
    SCROLL = "overflow-scroll",
}

/**
 * Position classes
 */
export enum POSITION {
    RELATIVE = "position-relative",
    STATIC = "position-static",
    ABSOLUTE = "position-absolute",
    FIXED = "position-fixed",
    STICKY = "position-sticky",
}

/** Css classes to add style 'box-shadow' elevation */
export enum SHADOW {
    S1 = "shadow-1",
    S2 = "shadow-2",
    S3 = "shadow-3",
    S4 = "shadow-4",
    S5 = "shadow-5",
    S6 = "shadow-6",
    S7 = "shadow-7",
    S8 = "shadow-8",
    S9 = "shadow-9",
    S10 = "shadow-10",
    S11 = "shadow-11",
    S12 = "shadow-12",
}

/**
 * Font weight classes
 */
export enum FONT_WEIGHT {
    BOLD = "fw-bold",
    BOLDER = "fw-bolder",
    SEMI_BOLD = "fw-semibold",
    NORMAL = "fw-normal",
    LIGHT = "fw-light",
    LIGHTER = "fw-lighter",
}

/**
 * Font style classes
 */
export enum FONT_STYLE {
    ITALIC = "fst-italic",
    NORMAL = "fst-normal"
}

/**
 * Flex gap style classes
 */
export enum FLEX_GAP {
    GAP_0 = "gap-0",
    GAP_1 = "gap-1",
    GAP_2 = "gap-2",
    GAP_3 = "gap-3",
    GAP_4 = "gap-4",
    GAP_5 = "gap-5"
}

/**
 * Text color bootstrap style classes
 * @see https://getbootstrap.com/docs/5.0/utilities/colors/
 */
export enum TEXT_COLOR {
    PRIMARY = "text-primary",
    SECONDARY = "text-secondary",
    SUCCESS = "text-success",
    DANGER = "text-danger",
    WARNING = "text-warning",
    INFO = "text-info",
    LIGHT = "text-light",
    DARK = "text-dark",
    WHITE = "text-white",
    MUTED = "text-muted"
}

/**
 * Background color bootstrap style classes
 * @see https://getbootstrap.com/docs/5.0/utilities/background/
 */
export enum BACKGROUND_COLOR {
    PRIMARY = "bg-primary",
    SECONDARY = "bg-secondary",
    SUCCESS = "bg-success",
    DANGER = "bg-danger",
    WARNING = "bg-warning",
    INFO = "bg-info",
    LIGHT = "bg-light",
    DARK = "bg-dark",
    WHITE = "bg-white"
}

/**
 * Use border utilities to add or remove an element’s borders. Choose from all borders or one at a time.
 * Add border of element
 * @see https://getbootstrap.com/docs/5.0/utilities/borders/
 */
export enum BORDER {
    ALL = "border",
    TOP = "border-top",
    BOTTOM = "border-bottom",
    START = "border-start",
    END = "border-end"
}

/** 
 * Remove border subtractive of element
 * @see https://getbootstrap.com/docs/5.0/utilities/borders/
 */
export enum BORDER_SUBTRACTIVE {
    ALL = "border-0",
    TOP = "border-top-0",
    BOTTOM = "border-bottom-0",
    START = "border-start-0",
    END = "border-end-0"
}

/** 
 * Set border-width of element
 * @see https://getbootstrap.com/docs/5.0/utilities/borders/
 */
export enum BORDER_WIDTH {
    BORDER_1 = "border-1",
    BORDER_2 = "border-2",
    BORDER_3 = "border-3",
    BORDER_4 = "border-4",
    BORDER_5 = "border-5"
}

/** 
 * Set border-radius of element
 * @see https://getbootstrap.com/docs/5.0/utilities/borders/
 */
export enum BORDER_RADIUS {
    ROUNDED = "rounded",
    ROUNDED_TOP = "rounded-top",
    ROUNDED_BOTTOM = "rounded-bottom",
    ROUNDED_START = "rounded-start",
    ROUNDED_END = "rounded-end",
    ROUNDED_CIRCLE = "rounded-circle",
    ROUNDED_PILL = "rounded-pill"
}

/** 
 * Set border-radius size of element
 * @see https://getbootstrap.com/docs/5.0/utilities/borders/
 */
export enum BORDER_RADIUS_SIZE {
    ROUNDED_0 = "rounded-0",
    ROUNDED_1 = "rounded-1",
    ROUNDED_2 = "rounded-2",
    ROUNDED_3 = "rounded-3"
}